var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.caption))]),_c('v-card-text',[_vm._t("default"),_c('div',{staticClass:"text-right mt-4"},[_vm._t("actions")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }